/**
 * Stable per-device identifier sent as X-Device-Fingerprint on every API
 * request (see api/security/device_fingerprint.py, which only checks shape
 * + trusted-device lookup -- it never recomputes this value). Persisted in
 * localStorage so it survives reloads and matches across a session; a
 * fresh browser profile / cleared storage looks like a "new device" to the
 * backend, which is the correct behavior (that's what should trigger MFA
 * step-up and an untrusted-device state).
 */
const STORAGE_KEY = "beekeeper.device_fingerprint";

export function getDeviceFingerprint() {
  let fingerprint = localStorage.getItem(STORAGE_KEY);
  if (!fingerprint) {
    fingerprint = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, fingerprint);
  }
  return fingerprint;
}

export function getDeviceName() {
  const ua = navigator.userAgent;
  const platform = navigator.platform || "";
  if (/iphone/i.test(ua)) return "iPhone";
  if (/ipad/i.test(ua)) return "iPad";
  if (/android/i.test(ua)) return /mobile/i.test(ua) ? "Android phone" : "Android tablet";
  if (/mac/i.test(platform)) return "Mac";
  if (/win/i.test(platform)) return "Windows PC";
  if (/linux/i.test(platform)) return "Linux PC";
  return "Unknown device";
}

export function isMobileDevice() {
  return /iphone|ipad|android|mobile/i.test(navigator.userAgent);
}
